/* eslint-disable linebreak-style */

import {
  ArrowLeftOutlined,
  CalendarOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  CloseOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  EditOutlined,
  FileExcelOutlined,
  ShareAltOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import { Button, DatePicker, Form, Input, Modal, notification, Spin, Table, Tooltip, Typography } from 'antd';
import { Button as CrcButton, Checkbox, Spinner } from '@crc-evans/ui-components';
import { FileSpreadsheet, LayoutTemplate, Plus, Upload } from 'lucide-react';
import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';
import { get } from 'lodash';
import moment from 'moment';
import { downloadDataAsExcel } from '../../utils/downloadExcelUtils';
import axios from 'axios';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import ProjectModal from './ProjectModal.js';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
//ag grid enterprise
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { MultiFilterModule } from '@ag-grid-enterprise/multi-filter';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { StatusBarModule } from '@ag-grid-enterprise/status-bar';
import {
  fetchCalibration,
  shareCalibration,
  uploadCalibrationFile,
} from '../../redux/calibration/action';
import history from '../../services/history';
import { CustomLoadingCellRenderer } from './Uitiles.js';
import {
  DeleteDetails,
  OnUploadFilesToS3,
  UploadBulkProjects,
  uploadPDFFileToS3Bucket,
} from '../../redux/calibration/saga.js';
import axiosConfig from '../../redux/calibration/calibrationAxiosConfig.js';
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
// Import PDF.js for rendering PDFs as images (handles complex PDF structures)
import * as pdfjsLib from 'pdfjs-dist';
// Set worker path for PDF.js
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
import { generateCombinedPdfReport } from '../../utils/combinedPdfReportUtils';
import { useHeatStyleColumnFacets } from '../technical/heatStyleColumnFacets';

const CALIBRATION_DATE_COLUMN_KEYS = ['CalibrationDate', 'NextCalibrationDate', 'Expiration'];

/** Text columns with Heat-style funnel + header search (matches `columnList` minus date columns). */
const CALIBRATION_TEXT_FACET_COLUMNS = [
  'ID',
  'Instrument_Company',
  'Identification',
  'Code_Model',
  'Manufacturer_Company',
  'SerialNumber',
  'Frequency',
  'Status',
  'StorageArea',
  'CertificateNumber',
  'Project',
  'ProjectNo',
  'Location',
  'RangeOfUse',
  'PermissibleError',
  'StandardCertificateNumber',
  'NameLaboratory',
  'Comments',
];

const CALIBRATION_BULK_UPLOAD_ACCEPT =
  '.xlsx,.xls,.pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/pdf';

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MenuModule,
  SetFilterModule,
  StatusBarModule,
  RowGroupingModule,
  MultiFilterModule,
]);

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_ENTERPRISE_LICENSE);

const { Title, Text } = Typography;

const CalibrationMainPage = (props) => {
  const {
    rawDataList,
    isRawListLoading,
    isUploadCalibration,
    calibrationTotalCount,
    onFetchCalibration,
    onShareCalibration,
    embeddedInModernLayout = false,
  } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editRecord, seteditRecord] = useState('');
  const [projectDetailForm] = Form.useForm();
  const [showPipelineModel, setShowPipelineModel] = useState(false);
  const [projectDetails, setProjectDetails] = useState(null);

  const [theme, setTheme] = useState('ag-theme-material-dark'); // Default theme
  const gridRef = useRef();
  const [columnDefs, setColumnDefs] = useState([]);
  const [layoutSave, setLayoutSave] = useState(false);
  const [layoutLoad, setLayoutLoad] = useState(false);
  const [isPivotMode, setIsPivotMode] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [pageSize, setPageSize] = useState(100000);
  const [pageNumber, setPageNumber] = useState(1);
  const [loadingData, setloadingData] = useState(false);
  const [selectModel, setSelectModel] = useState([]);

  const [calibrationFormModal, setCalibrationFormModal] = useState(false);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [shareCalibrationModal, setShareCalibrationModal] = useState(false);
  const [emailAddress, setEmailAddress] = useState('');
  const [calibrationCertificateId, setcalibrationCertificateId] = useState(0);
  const [expiryDateSearch, setExpiryDateSearch] = useState('');
  const [searchText, setSearchText] = useState('');
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileList1, setFileList1] = useState([]);
  const [paginationClear, setPaginationClear] = useState(false);
  const [editValue, setEditValue] = useState(false);
  const [calibrationRecord, setCalibrationRecord] = useState({});
  const [editData, setEditData] = useState({});
  const [searchCriteria, setSearchCriteria] = useState({});

  /* Modern layout: column filters and pagination */
  const [columnFilters, setColumnFilters] = useState({});
  const [filterCalibrationDate, setFilterCalibrationDate] = useState(null);
  const [filterNextCalibrationDate, setFilterNextCalibrationDate] = useState(null);
  const [filterExpiration, setFilterExpiration] = useState(null);
  const [modernPageNumber, setModernPageNumber] = useState(1);
  const [modernPageSize, setModernPageSize] = useState(10);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState('');
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [pdfGenerationLoading, setPdfGenerationLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const columnList = {
    ID: 'ID',
    Instrument_Company: 'Instrument Name',
    Identification: 'Identification',
    Code_Model: 'Code/Model',
    Manufacturer_Company: 'Manufacturer/Company',
    SerialNumber: 'Serial Number',
    Frequency: 'Frequency',
    Status: 'Status of Instrument',
    StorageArea: 'Storage Area',
    CertificateNumber: 'Certificate Number',
    CalibrationDate: 'Calibration Date',
    NextCalibrationDate: 'Next Calibration Date',
    Expiration: 'Expiration',
    Project: 'Project Name',
    ProjectNo: 'Project Number',
    Location: 'Location',
    RangeOfUse: 'Range of Use',
    PermissibleError: 'Permissible Error',
    StandardCertificateNumber: 'Standard Certificate Number',
    NameLaboratory: 'Name Laboratory',
    Comments: 'Comments',
  };

  const searchCriteriaForFacets = useMemo(() => ({}), []);
  const rawDataListRef = useRef([]);
  rawDataListRef.current = Array.isArray(rawDataList) ? rawDataList : [];

  const fetchCalibrationFacetRows = useCallback(async () => {
    const list = rawDataListRef.current;
    return Array.isArray(list) ? [...list] : [];
  }, []);

  const handleColumnFilterChange = useCallback((key, value) => {
    setColumnFilters((prev) => ({ ...prev, [key]: value }));
    if (embeddedInModernLayout) setModernPageNumber(1);
  }, [embeddedInModernLayout]);

  const { columnSelectedValues, applyFacetClientFilter, renderTextColumnFilterTrigger } =
    useHeatStyleColumnFacets({
      enabled: embeddedInModernLayout,
      filterableColumns: CALIBRATION_TEXT_FACET_COLUMNS,
      listCount: Array.isArray(rawDataList) ? rawDataList.length : 0,
      projectList: rawDataList,
      searchCriteria: searchCriteriaForFacets,
      columnFilters,
      onColumnFilterChange: handleColumnFilterChange,
      fetchFacetRows: fetchCalibrationFacetRows,
    });

  const generateColumns = async (columnList) => {
    const columnDefs = Object.keys(columnList).map((key, index) => {
      const isReducedWidthColumn = ['ID'].includes(key); // Columns like ID will have a reduced width
      const isDateColumn = ['CalibrationDate', 'NextCalibrationDate', 'Expiration'].includes(key);
      const isDateColumn1 = [
        'Instrument_Company',
        'Manufacturer_Company',
        'Code_Model',
        'Identification',
        'SerialNumber',
      ].includes(key);
      // Dynamically calculate column width based on header length with ample padding
      // Increased multiplier to 25 to account for uppercase headers and padding
      const calculatedWidth = Math.max(columnList[key].length * 25 + 100, 300);

      return {
        field: key,
        field: key,
        headerName: columnList[key],
        resizable: true,
        filter: 'agMultiColumnFilter',
        checkboxSelection: index === 0, // ✅ checkbox on first column
        headerCheckboxSelection: index === 0, // ✅ "select all" checkbox in header
        headerCheckboxSelectionFilteredOnly: true,
        suppressSizeToFit: true, // Prevent grid from auto-sizing to fit
        filterParams: {
          filters: [
            {
              filter: 'agTextColumnFilter',
            },
            {
              filter: 'agSetColumnFilter',
            },
          ],
        },
        // Max width calculation, with specific logic for reduced width columns like 'ID'
        maxWidth: isReducedWidthColumn ? 120 : null,
        minWidth: isReducedWidthColumn ? 100 : calculatedWidth,
        width: isReducedWidthColumn ? 100 : calculatedWidth, // Explicitly set width to force scrolling
        flex: 0, // Disable flex to prevent shrinking

        valueFormatter: (params) => {
          if (isDateColumn) {
            const date = moment(params.value); // Parse date with moment.js
            return date.isValid() ? date.format('DD-MMM-YYYY') : ''; // Format if valid, empty if invalid
          }
          return params.value;
        },

        cellStyle: {
          textAlign: ['ID'].includes(key) || isDateColumn1 ? 'left' : 'center',
        },

        // headerClass: 'custom-header-class', // Add a custom CSS class for styling the header
      };
    });

    // Add the actions column at the end
    columnDefs.push({
      headerName: 'Actions',
      field: 'action',
      // pinned: 'right', // ❌ Unpinned as requested
      width: 200, // Fixed width for the Actions column
      cellRenderer: (params) => {
        const record = params.data;
        const max = record.certificate_history.reduce((prev, current) => {
          const prevVersion = parseFloat(prev?.version) || 0;
          const currentVersion = parseFloat(current?.version) || 0;
          return currentVersion > prevVersion ? current : prev;
        });
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Tooltip title="Update">
              <Button
                className="p-0 border-0"
                size="small"
                target="_blank"
                style={{ marginRight: '10px' }}
              >
                <EditOutlined className="pdfIconRed" onClick={() => onUpdateClick(record)} />
              </Button>
            </Tooltip>
            {max?.certificateURL && (
              <Tooltip title="Download">
                <Button
                  className="p-0 border-0"
                  size="small"
                  target="_blank"
                  style={{ marginRight: '10px' }}
                  href={max?.certificateURL}
                >
                  <FileExcelOutlined className="pdfIconRed" />
                </Button>
              </Tooltip>
            )}
            {max?.certificateURL && (
              <Tooltip title="Share Certificate">
                <Button
                  className="p-0 border-0"
                  size="small"
                  target="_blank"
                  style={{ marginRight: '10px' }}
                  onClick={() => showShareCalibrationModal(record)}
                >
                  <ShareAltOutlined className="pdfIconRed" style={{ marginRight: '00px' }} />
                </Button>
              </Tooltip>
            )}
            {/* <Tooltip title="Delete">

                            <Button
                                className="p-0 border-0"
                                size="small"
                                target="_blank"
                                style={{ marginRight: '10px' }}
                                onClick={() => showDeleteModal(record)}
                            >
                                <DeleteOutlined className="pdfIconRed" style={{ marginRight: '00px' }} />
                            </Button>
                        </Tooltip> */}
          </div>
        );
      },
      cellStyle: { textAlign: 'center' },
      filter: false, // Disable filtering for the Actions column
    });

    // console.log(columnList, columnDefs);
    setColumnDefs(columnDefs);
    return columnDefs;
  };

  // Helper function to render PDF page as image using PDF.js
  // This reliably handles complex PDF structures by converting pages to images
  const renderPdfPageAsImage = async (pdfBytes, pageNumber) => {
    try {
      const loadingTask = pdfjsLib.getDocument({
        data: new Uint8Array(pdfBytes),
        useSystemFonts: true,
        verbosity: 0 // Suppress warnings
      });
      const pdf = await loadingTask.promise;
      const page = await pdf.getPage(pageNumber);

      // High-quality raster rendering for combined PDF output
      const viewport = page.getViewport({ scale: 2.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render the page to canvas
      await page.render({
        canvasContext: context,
        viewport: viewport
      }).promise;

      // Convert canvas to data URL
      return canvas.toDataURL('image/png');
    } catch (error) {
      return null;
    }
  };

  const handleGeneratePdf = async () => {
    // Set loading state and disable button
    setPdfGenerationLoading(true);

    try {
      // Get certificate URL function for Calibration
      const getCertificateUrl = async (row) => {
        const certificateHistory = row?.certificate_history || [];
        if (certificateHistory.length === 0) {
          return null;
        }

        // Find latest version certificate (highest version number)
        const latestCert = certificateHistory.reduce((prev, current) => {
          const prevVersion = parseFloat(prev?.version) || 0;
          const currentVersion = parseFloat(current?.version) || 0;
          return currentVersion > prevVersion ? current : prev;
        });

        return latestCert?.certificateURL || null;
      };

      // Table configuration for Calibration
      const getColumnWidths = (font, tableWidth, padding, fontSize) => {
        const seqWidth = font.widthOfTextAtSize('Seq', fontSize) + padding;
        const identificationWidth = font.widthOfTextAtSize('Identification', fontSize) + padding;
        const serialWidth = font.widthOfTextAtSize('Serial Number', fontSize) + padding;
        const expirationWidth = font.widthOfTextAtSize('Expiration Date', fontSize) + padding;
        const equipmentWidth = tableWidth - (seqWidth + identificationWidth + serialWidth + expirationWidth);

        return {
          seq: seqWidth,
          identification: identificationWidth,
          equipment: equipmentWidth,
          serial: serialWidth,
          expiration: expirationWidth,
        };
      };

      const formatRowData = (row, index) => {
        const formatDate = (val) => {
          if (!val) return '-';
          const date = moment(val);
          return date.isValid() ? date.format('DD-MMM-YYYY') : val;
        };

        return [
          row?.ID?.toString() || '-',
          row?.Identification || '-',
          row?.Instrument_Company || '-',
          row?.SerialNumber?.toString() || '-',
          formatDate(row?.Expiration),
        ];
      };

      // Generate PDF using common utility
      const result = await generateCombinedPdfReport({
        selectedRows,
        renderPdfPageAsImage,
        getCertificateUrl,
        reportConfig: {
          heading: 'Project Test Equipment Certificates',
          section1Title: '1.0 Certified Calibration Equipment Summary',
          section2Title: '2.0 Test Equipment Calibration Certificates',
          fileName: 'Combined Report.pdf',
        },
        tableConfig: {
          headers: ['Seq', 'Identification', 'Equipment', 'Serial Number', 'Expiration Date'],
          getColumnWidths,
          formatRowData,
          styling: {
            rowHeight: 25,
            fontSize: 9,
            headerFontSize: 10,
            enableTextWrapping: false,
          },
        },
      });

      // Show notification to user
      if (result.successCount > 0) {
        notification.success({
          message: 'PDF Generated Successfully',
          description: `Merged ${result.successCount} certificate(s) with ${result.totalPages} total page(s).`,
          duration: 5,
        });
      }
      if (result.failCount > 0) {
        notification.warning({
          message: 'Some PDFs Failed to Merge',
          description: `${result.failCount} certificate(s) could not be merged.`,
          duration: 5,
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error Generating PDF',
        description: error.message || 'An error occurred while generating the PDF.',
        duration: 5,
      });
    } finally {
      // Always reset loading state when done (success or error)
      setPdfGenerationLoading(false);
    }
  };

  useEffect(() => {
    generateColumns(columnList);
  }, []);
  useEffect(() => {
    if (embeddedInModernLayout) return;
    if (rawDataList.length == 0) {
      onFetchCalibration();
    } else fetchData(rawDataList);
  }, [embeddedInModernLayout]);
  useEffect(() => {
    if (!embeddedInModernLayout) return;
    onFetchCalibration();
  }, [embeddedInModernLayout]);

  // useEffect(() => {
  //     if (rawDataList.length == 0) {
  //         onFetchRawList({ tableName: 'ZPAL_GLOBAL', pageNumber: pageNumber, pageSize: pageSize });

  //     }
  // }, [])\\
  const fetchCalibrationData = async () => {
    await onFetchCalibration();
  };
  const fetchData = async (data) => {
    if (data.length > 0) {
      setLayoutLoad(false);
      //generateColumns(data[0]);
      setRowData(data);
      setLayoutLoad(true);
      setLoadingProgress(100);
    }
  };

  /** Deleting Spare parts data on confirm */
  const handleDeleteOk = async () => {
    {
      setIsDeleteLoading(true);
      const obj = {
        columnName: 'Project_Details',
        tableName: 'Project_Details',
        data: selectedData,
      };
      // console.log(obj);
      await DeleteDetails(obj);

      setSelectedData('');
      onFetchCalibration();
      setIsDeleteLoading(false);
      setIsDeleteModalVisible(false);
    }
  };
  /** Display Confirmation while deleting */
  const showDeleteModal = (record) => {
    setIsDeleteModalVisible(true);
    setSelectedData(record);
  };

  /** Cancelling the deletion of spare parts data */
  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
  };

  const onUpdateClick = (record) => {
    projectDetailForm.setFieldsValue(record);
    //console.log(record)
    seteditRecord(record);
    setIsEdit(true);
    setIsModalVisible(true);
  };

  const onViewClick = (record) => {
    setProjectDetails(record);
    //console.log(record)
    seteditRecord(record);
    //setIsEdit(true)
    setShowPipelineModel(true);
  };
  // const fileProps2 = {
  //     onRemove: (file) => {
  //         const index = fileList.indexOf(file);
  //         const newFileList = fileList.slice();
  //         newFileList.splice(index, 1);
  //         setFileList1(newFileList);
  //     },
  //     beforeUpload: (file) => {
  //         setFileList1([file]);
  //         return false;
  //     },
  //     fileList1,
  // };

  const handleCalibrationFileInputChange = (event) => {
    const input = event?.target;
    const selectedFiles = Array.from(input?.files || []);
    if (!selectedFiles.length) return;

    setFileList((prev) => {
      const next = [...prev];
      const existingKeys = new Set(prev.map((f) => `${f.name}::${f.size}::${f.lastModified}`));

      selectedFiles.forEach((f) => {
        const key = `${f.name}::${f.size}::${f.lastModified}`;
        if (!existingKeys.has(key)) {
          existingKeys.add(key);
          next.push(f);
        }
      });

      return next.slice(0, 100);
    });

    // Let users pick the same file again after remove/reset.
    if (input) input.value = '';
  };

  const getCalibrationFileKey = (file) => `${file.name}::${file.size}::${file.lastModified}`;

  const removeCalibrationSelectedFile = (fileToRemove) => {
    const removeKey = getCalibrationFileKey(fileToRemove);
    setFileList((prev) => prev.filter((f) => getCalibrationFileKey(f) !== removeKey));
  };

  const clearCalibrationFileSelection = () => {
    setFileList([]);
  };

  useEffect(() => {
    //console.log('rawDataList updated:', rawDataList.length);

    if (rawDataList) fetchData(rawDataList);
  }, [rawDataList]);

  const onRowDragEnd = (event) => {
    const { node, overNode } = event;
    if (!overNode) return;

    const draggedRow = node.data;
    const fromIndex = node.rowIndex;
    const toIndex = overNode.rowIndex;

    if (fromIndex === toIndex) return;

    const newRowData = [...rowData];
    newRowData.splice(fromIndex, 1);
    newRowData.splice(toIndex, 0, draggedRow);

    setRowData(newRowData);
  };

  // useEffect(() => {
  //     if (layoutSave && gridRef) {
  //         (async () => {
  //             let layouts = {}
  //             await saveGridLayout(gridRef, currentTab, layouts, setLayoutSave);
  //         })();

  //     }

  // }, [layoutSave])

  // useEffect(() => {
  //     if (layoutLoad && gridRef) {
  //         (async () => {
  //             await restoreGridLayout(gridRef, currentTab, setIsPivotMode);
  //             setLayoutLoad(false)
  //         })();

  //     }
  // }, [layoutLoad])

  const gridStyle = useMemo(() => ({ height: '99%', width: '100%' }), []);

  const defaultColDef = useMemo(() => {
    return {
      flex: 0, // Disable flex to prevent auto-sizing
      suppressSizeToFit: true, // Ensure columns respect their width
      minWidth: 150,
      floatingFilter: true,
      resizable: true,
      enableValue: true,
      enableRowGroup: true,
      enablePivot: true,
      filter: true,
      // wrapHeaderText: true,
      // autoHeaderHeight: true,
    };
  }, []);

  const activeKeyLine = 'Calibration';
  const defaultExcelExportParams = useMemo(() => {
    return {
      fileName: `${activeKeyLine}.xlsx`, // Default file name
      allColumns: true, // Include all columns by default
      onlySelected: false, // Include all rows, not just selected ones
      sheetName: 'Sheet1', // Default sheet name
    };
  }, [activeKeyLine]);
  const defaultCsvExportParams = useMemo(() => {
    return {
      fileName: `${activeKeyLine}.csv`, // Default file name
      allColumns: true, // Include all columns by default
      onlySelected: false, // Include all rows, not just selected ones
    };
  }, [activeKeyLine]);

  const rowSelection = useMemo(() => {
    return {
      mode: 'singleRow',
      checkboxes: false, // ❌ disables checkboxes
      enableClickSelection: false,
    };
  }, []);

  const onGridReady = useCallback(
    (params) => {
      setGridApi(params.api);
      // console.log("params", params.api)
      if (isRawListLoading) {
        params.api.showLoadingOverlay();
      } else {
        params.api.hideOverlay();
      }
    },
    [isRawListLoading]
  );

  // useEffect(() => {
  //     if (gridRef.current) {
  //         if (loadingData) {
  //             gridRef.current.api.showLoadingOverlay();
  //         } else {
  //             gridRef.current.api.hideOverlay();
  //         }
  //     }
  // }, [loadingData])

  //

  useEffect(() => {
    if (isRawListLoading) {
      setLoadingProgress(0);

      const interval = setInterval(() => {
        setLoadingProgress((prevProgress) => {
          const nextProgress = prevProgress + 10;
          if (nextProgress >= 100) {
            clearInterval(interval);
            return 100;
          }
          return nextProgress;
        });
      }, 500);

      return () => clearInterval(interval); // cleanup on unmount
    }
  }, [isRawListLoading]);

  useEffect(() => {
    if (isRawListLoading && gridRef.current) {
      // Update the overlay with the current progress
      const loadingOverlayTemplate = `
                <div class="custom-loading-overlay">
                    <span>Loading... ${loadingProgress}%</span>
                </div>
            `;
      // gridRef.current.api.showLoadingOverlay();
      // gridRef.current.api.setOverlayLoadingTemplate(loadingOverlayTemplate);
    }
  }, [loadingProgress, isRawListLoading]);

  // Custom status panel component
  // const CustomStatusPanel = ({ refreshInfo }) => {
  //     return <div style={{ paddingTop: '20px' }}>{refreshInfo}</div>;
  // };

  const statusBar = {
    statusPanels: [
      {
        statusPanel: 'agTotalRowCountComponent',
        align: 'left',
      },
      {
        statusPanel: 'agSelectedRowCountComponent',
        align: 'left',
      },
      {
        statusPanel: 'agFilteredRowCountComponent',
        align: 'left',
      },
      // {
      //     statusPanel: () => <CustomStatusPanel refreshInfo={refreshInfo} />, // React component
      //     align: 'right',
      // },
    ],
  };
  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const onSelectionChanged = () => {
    const selectedRows = gridRef.current.api.getSelectedRows();
    // console.log('Selected Row Details:', selectedRows);
    setSelectModel(selectedRows);
    // You can do further processing with selectedRows here, e.g., updating state
  };

  // function onCellDoubleClicked(event) {

  //     console.log(
  //         event
  //     );
  //     if (event)
  //         onViewClick(event.data)

  // }
  const showShareCalibrationModal = async (record) => {
    setcalibrationCertificateId(record.ID);
    setShareCalibrationModal(true);
  };

  const handleCancelUploadFile = () => {
    setFileList([]);
    setBulkUploadModal(false);
    setDisableFileUpload(false);
  };

  const handleCancelShareCalibrationModal = () => {
    setShareCalibrationModal(false);
    setEmailAddress('');
  };

  const shareCalibration = async () => {
    const emailAddressArray = emailAddress.split(',');
    await onShareCalibration({ calibrationCertificateId, emailAddress: emailAddressArray });
    setShareCalibrationModal(false);
    setEmailAddress('');
  };

  const getPipelineTabpanes = () => {
    return (
      <div className="custom-tab h-100" style={{ paddingTop: '0px' }}>
        <div style={{ height: 'calc(100vh - 120px)', overflow: 'auto', position: 'relative' }}>
          <div className={`ag-grid ${theme} custom-grid-theme`} style={gridStyle}>
            <AgGridReact
              ref={gridRef}
              rowData={rowData}
              columnDefs={columnDefs}
              rowDragManaged={true}
              onRowDragEnd={onRowDragEnd}
              defaultColDef={defaultColDef}
              // rowSelection={rowSelection}
              onGridReady={onGridReady}
              sideBar={false}
              pivotMode={isPivotMode}
              //
              pivotPanelShow={'always'}
              autoGroupColumnDef={autoGroupColumnDef}
              animateRows={true}
              // onSelectionChanged={onSelectionChanged}
              // enableFilter={true}
              statusBar={statusBar}
              rowHeight={40}
              headerHeight={50}
              defaultExcelExportParams={defaultExcelExportParams}
              defaultCsvExportParams={defaultCsvExportParams}
              loadingOverlayComponent={CustomLoadingCellRenderer}
              loadingOverlayComponentParams={{
                loadingMessage: 'Loading all rows...',
              }}
              //onCellDoubleClicked={onCellDoubleClicked}

              rowSelection="multiple"
              onSelectionChanged={(event) => {
                const selected = event.api.getSelectedRows();
                setSelectedRows(selected);
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  const createExcelTemplate1 = async () => {
    const workbook = new ExcelJS.Workbook();
    const calibrationSheet = workbook.addWorksheet('calibration');

    // Set Header Row Height
    const headerRow = calibrationSheet.getRow(1);
    headerRow.height = 60;

    const columns = Object.keys(columnList).map((key) => ({
      header: columnList[key],
      key: key,
      width: 20,
    }));
    // Add "Local File Path" column
    columns.push({
      header: 'fileURL',
      key: 'fileURL', // Use a string key instead of a number
      width: 20,
    });

    // Set columns in the sheet
    calibrationSheet.columns = columns;

    // Sort array in descending order based on ID
    const sortedData = rawDataList.sort((a, b) => b.ID - a.ID);
    // Extract file URL from certificate_history
    const transformedData = sortedData.map((item) => {
      const fileURL = item.certificate_history?.[0]?.certificateURL?.fileURL || null; // Extract first fileURL if available
      return { ...item, fileURL }; // Add fileURL outside of certificate_history
    });

    // Ensure proper header styling (optional)
    headerRow.eachCell((cell) => {
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.font = { bold: true };
    });
    // Set columns in the sheet
    calibrationSheet.columns = columns;

    // Add data to the worksheet
    ws.addRows(transformedData);

    return await workbook.xlsx.writeBuffer();
  };

  const createExcelTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const calibrationSheet = workbook.addWorksheet('calibration');

    // Set Header Row Height
    const headerRow = calibrationSheet.getRow(1);
    headerRow.height = 20;

    const columns = Object.keys(columnList)
      .filter((item) => item !== 'ID')
      .map((key) => ({
        header: columnList[key],
        key: key,
        width: 20,
      }));
    // Set columns in the sheet
    calibrationSheet.columns = columns;
    return await workbook.xlsx.writeBuffer();
  };

  const showBulkUploadModal = () => {
    setBulkUploadModal(true);
  };
  const handleUploadFile = async () => {
    if (fileList.length > 0) {
      // await onUploadCalibrationFile({ fileList, isExcelUpload: 1 });
      await handleSiteUploadFile2();
    } else {
      notification.warn({ message: 'Please select a file to upload.' });
    }
  };

  // Function to upload files to S3
  const uploadFilesToS3 = async () => {
    try {
      const uploadedFiles = [];

      if (fileList && fileList.length > 0) {
        const fileObjs = fileList.slice(0).map((file) => ({
          fileName: file.name.replace(/\(\d+\)/g, '').trim(), // Remove (1), (2), etc.
          contentType: file.type,
        }));

        // Get signed URLs for multiple files
        const response = await axiosConfig.post(`GetPresignedUrl`, { files: fileObjs });
        if (response.status === 200) {
          for (const data of response.data.data) {
            const file = fileList.find(
              (f) => f.name.replace(/\(\d+\)/g, '').trim() === data.fileName
            ); // Match sanitized filename
            if (file) {
              try {
                // Upload file to S3
                const uploadResponse = await axios.put(data.presignedUrl, file, {
                  headers: {
                    'Content-Disposition': 'attachment',
                    'Content-Type': file.type || 'application/octet-stream',
                  },
                });

                if (uploadResponse.status === 200) {
                  uploadedFiles.push({ s3Url: data.fileUrl, fileName: data.fileName });
                } else {
                  console.error(`Error uploading file: ${file.name}`, uploadResponse);
                }
              } catch (error) {
                console.error(`Error processing file: ${file.name}`, error);
              }
            }
          }
        }

        setFileList([]); // Clear selected files after upload
      }
      return uploadedFiles;
    } catch (error) {
      console.error('Error uploading files:', error);
    }
  };

  const ExcelDateToJSDate = (date) => {
    const convertedDate = new Date(Math.round((date - 25569) * 864e5));
    return String(convertedDate).slice(4, 15);
  };

  const handleSiteUploadFile2 = async () => {
    if (fileList.length === 0) {
      notification.warn({ message: 'Please select files to upload.' });
      return;
    }

    const excelFile = fileList[0];
    const otherFiles = fileList.slice(1); // Remaining files after Excel

    if (!excelFile || !excelFile.name.match(/\.(xlsx|xls)$/i)) {
      notification.warn({ message: 'First file should be a valid Excel file.' });
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        if (jsonData.length <= 1) {
          notification.error({ message: 'Invalid Excel content.' });
          return;
        }

        const keyMapping = {
          Instrument_Company: 'Instrument Name',
          Identification: 'Identification',
          Code_Model: 'Code/Model',
          Manufacturer_Company: 'Manufacturer/Company',
          SerialNumber: 'Serial Number',
          Frequency: 'Frequency',
          Status: 'Status of Instrument',
          StorageArea: 'Storage Area',
          CertificateNumber: 'Certificate Number',
          CalibrationDate: 'Calibration Date',
          NextCalibrationDate: 'Next Calibration Date',
          Expiration: 'Expiration',
          Project: 'Project Name',
          ProjectNo: 'Project Number',
          Location: 'Location',
          RangeOfUse: 'Range of Use',
          PermissibleError: 'Permissible Error',
          StandardCertificateNumber: 'Standard Certificate Number',
          NameLaboratory: 'Name Laboratory',
          Comments: 'Comments',
        };
        const swappedKeyMapping = Object.fromEntries(
          Object.entries(keyMapping).map(([k, v]) => [v, k])
        );

        const headers = jsonData[0];
        const formattedData = jsonData.slice(1).map((row, index) => {
          const rowData = {};
          headers.forEach((header, i) => {
            const mappedKey = swappedKeyMapping[header];
            const value = row[i]; // <-- Correct value access

            if (
              header === 'Calibration Date' ||
              header === 'Next Calibration Date' ||
              header === 'Expiration'
            ) {
              let formattedDate = '';

              if (value) {
                formattedDate = moment(value, [
                  'DD-MM-YYYY',
                  'D-M-YY',
                  'DD-MM-YY',
                  'MM-DD-YYYY',
                ]).format('YYYY-MM-DD');

                if (!formattedDate || formattedDate.includes('Invalid')) {
                  const excelDate = ExcelDateToJSDate(value);
                  formattedDate = moment(excelDate).format('YYYY-MM-DD');
                }
              }

              rowData[mappedKey] = formattedDate || '';
            }

            // Special handling for Project and Project Number
            else if (header === 'Project Name' || header === 'Project') {
              rowData[mappedKey] = value === 'None' ? '' : value ?? '';
            } else if (header === 'Project Number') {
              rowData[mappedKey] = value === '0000' ? '' : value ?? '';
            } else if (header === 'Frequency') {
              rowData[mappedKey] = value ? `${value} months` : '';
            }

            // Normal fields
            else {
              rowData[mappedKey] = mappedKey ? value ?? '' : undefined;
            }
          });
          rowData['Reminders'] = '90';
          //rowData['ID'] = index + 1;
          return rowData;
        });

        setUploadLoading(true);
        // // Upload additional files
        // const uploadedFiles = await OnUploadFilesToS3(otherFiles.slice(0));
        // // Normalize function to remove spaces, symbols, and accents
        // const normalize = (str = '') => str.toString().toLowerCase().replace(/[^a-z0-9]/gi, '').replace(/\//g, ''); // Remove slashes too

        // //Process the data to match files
        // const historyData = formattedData.map((row) => {
        //     const cert = normalize(row.CertificateNumber);
        //     const company = normalize(row.Instrument_Company);

        //     // Try to find the file that matches both CertificateNumber and Instrument_Company
        //     const matchedFile = uploadedFiles.find(file => {
        //         const fileName = normalize(file.fileName);
        //         // Check if both certificate number and company are found in the filename
        //         return fileName.includes(cert) && fileName.includes(company);
        //     });

        //     return {
        //         CertificateNumber: row.CertificateNumber,
        //         Instrument_Company: row.Instrument_Company,
        //         File_URL: matchedFile ? matchedFile.s3Url : null, // Set File_URL or null if no match
        //         Created_Date: new Date(),
        //         Updated_Date: new Date(),
        //     };
        // });

        const finalPayload = {
          data: formattedData,
          fileUrls: null,
        };
        await UploadBulkProjects(finalPayload);
        await onFetchCalibration();
        setUploadLoading(false);
        setBulkUploadModal(false);
        setFileList([]);
      } catch (error) {
        console.error('Error parsing Excel:', error);
        notification.error({ message: 'Error parsing Excel file.' });
      }
    };

    reader.readAsArrayBuffer(excelFile);
  };

  const handleDownloadTemplate = async () => {
    try {
      const data = await createExcelTemplate();
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Calibration Template.xlsx';
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      notification.error({ message: 'Failed to download template', description: err?.message });
    }
  };

  const handleDownloadData = async () => {
    const columns = Object.keys(columnList)
      .map((key) => ({
        header: columnList[key],
        key: key,
        width: 20,
      }));

    // Add additional columns
    columns.push({
      header: 'File URL',
      key: 'certificateURL',
      width: 30,
    });
    columns.push({
      header: 'Version',
      key: 'version',
      width: 15,
    });

    const dataFormatter = (record) => {
      let latestCert = record?.certificate_history?.reduce(
        (prev, current) => {
          const prevVersion = parseFloat(prev?.version) || 0;
          const currentVersion = parseFloat(current?.version) || 0;
          return currentVersion > prevVersion ? current : prev;
        },
        {}
      );

      return {
        ...record,
        CalibrationDate: moment(record.CalibrationDate).format('DD-MMM-YYYY'),
        NextCalibrationDate: moment(record.NextCalibrationDate).format('DD-MMM-YYYY'),
        Expiration: moment(record.Expiration).format('DD-MMM-YYYY'),
        certificateURL: latestCert?.certificateURL || '',
        version: latestCert?.version || '',
      };
    };

    const cellStyler = (worksheet, rowNumber, columnKey, cell, rowData) => {
      // Apply "button-like" style to the File URL column
      if (columnKey === 'certificateURL' && rowData?.certificateURL) {
        const url = rowData.certificateURL;
        cell.value = { text: 'Download File', hyperlink: url };
        cell.font = { color: { argb: 'FFFFFFFF' }, bold: true };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF0070C0' }, // Blue fill
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      }
    };

    await downloadDataAsExcel({
      data: rawDataList,
      fileName: 'List of calibration',
      columns,
      sheetName: 'calibration',
      dataFormatter,
      reverseData: true,
      cellStyler,
      setDownloadLoading,
    });
  };

  const handleSortClick = (columnKey) => {
    setSortField(columnKey);
    setSortOrder((prev) => (sortField === columnKey && prev === 'ascend' ? 'descend' : 'ascend'));
    setModernPageNumber(1);
  };

  const filteredDataForModern = useMemo(() => {
    if (!embeddedInModernLayout || !rawDataList || !rawDataList.length) return [];
    const textDateFiltered = rawDataList.filter((row) => {
      for (const key of CALIBRATION_TEXT_FACET_COLUMNS) {
        const sel = columnSelectedValues[key];
        if (sel != null && sel.size > 0) continue;
        const val = (columnFilters[key] || '').trim();
        if (!val) continue;
        const cell = row[key];
        const str = cell != null ? String(cell) : '';
        if (!str.toLowerCase().includes(val.toLowerCase())) return false;
      }
      if (filterCalibrationDate && row.CalibrationDate) {
        if (!moment(row.CalibrationDate).isSame(filterCalibrationDate, 'day')) return false;
      }
      if (filterNextCalibrationDate && row.NextCalibrationDate) {
        if (!moment(row.NextCalibrationDate).isSame(filterNextCalibrationDate, 'day')) return false;
      }
      if (filterExpiration && row.Expiration) {
        if (!moment(row.Expiration).isSame(filterExpiration, 'day')) return false;
      }
      return true;
    });
    return applyFacetClientFilter(textDateFiltered);
  }, [
    embeddedInModernLayout,
    rawDataList,
    columnFilters,
    columnSelectedValues,
    filterCalibrationDate,
    filterNextCalibrationDate,
    filterExpiration,
    applyFacetClientFilter,
  ]);

  const sortedDataForModern = useMemo(() => {
    if (!sortField || !sortOrder || !filteredDataForModern.length) return filteredDataForModern;
    const arr = [...filteredDataForModern];
    const isDate = CALIBRATION_DATE_COLUMN_KEYS.includes(sortField);
    const dir = sortOrder === 'ascend' ? 1 : -1;
    arr.sort((a, b) => {
      let va = a[sortField];
      let vb = b[sortField];
      if (isDate) {
        const ma = va ? moment(va).valueOf() : 0;
        const mb = vb ? moment(vb).valueOf() : 0;
        return dir * (ma - mb);
      }
      if (sortField === 'ID') {
        const na = Number(va);
        const nb = Number(vb);
        if (!Number.isNaN(na) && !Number.isNaN(nb)) return dir * (na - nb);
      }
      const sa = va != null ? String(va) : '';
      const sb = vb != null ? String(vb) : '';
      return dir * (sa.localeCompare(sb, undefined, { numeric: true }));
    });
    return arr;
  }, [filteredDataForModern, sortField, sortOrder]);

  const getLatestCert = (record) => {
    const hist = record?.certificate_history || [];
    return hist.reduce((prev, current) => {
      const pv = parseFloat(prev?.version) || 0;
      const cv = parseFloat(current?.version) || 0;
      return cv > pv ? current : prev;
    }, {});
  };

  const modernColumnsWithFilters = useMemo(() => {
    const keys = Object.keys(columnList);
    const cols = keys.map((key) => {
      const isDate = CALIBRATION_DATE_COLUMN_KEYS.includes(key);
      const label = columnList[key].toUpperCase().replace(/\s+/g, ' ');
      let title = label;
      if (isDate) {
        const dateVal = key === 'CalibrationDate' ? filterCalibrationDate : key === 'NextCalibrationDate' ? filterNextCalibrationDate : filterExpiration;
        const setDate = key === 'CalibrationDate' ? setFilterCalibrationDate : key === 'NextCalibrationDate' ? setFilterNextCalibrationDate : setFilterExpiration;
        title = (
          <div className="column-header-with-filter">
            <div className="column-header-text-wrapper">
              <span>{label}</span>
              <span
                className="custom-sort-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleSortClick(key); }}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSortClick(key); } }}
              >
                {sortField === key && sortOrder === 'ascend' && <CaretUpOutlined />}
                {sortField === key && sortOrder === 'descend' && <CaretDownOutlined />}
                {(!sortField || sortField !== key || !sortOrder) && (
                  <span className="sort-icon-placeholder"><CaretUpOutlined /></span>
                )}
              </span>
            </div>
            <div className="header-filter-input">
              <DatePicker
                className="heat-profile-header-date-picker"
                placeholder="Select date"
                size="small"
                style={{ width: '120px' }}
                format="DD-MMM-YYYY"
                value={dateVal}
                onChange={(d) => { setDate(d); setModernPageNumber(1); }}
                onClick={(e) => e.stopPropagation()}
                suffixIcon={dateVal ? (
                  <CloseOutlined className="heat-profile-date-clear-icon" onClick={(e) => { e.stopPropagation(); setDate(null); }} />
                ) : (
                  <CalendarOutlined className="heat-profile-date-icon" />
                )}
                dropdownClassName="heat-profile-datepicker-dropdown"
                allowClear={false}
              />
            </div>
          </div>
        );
      } else {
        title = (
          <div className="column-header-with-filter">
            <div className="column-header-text-wrapper">
              <span>{label}</span>
              <span
                className="custom-sort-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleSortClick(key); }}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSortClick(key); } }}
              >
                {sortField === key && sortOrder === 'ascend' && <CaretUpOutlined />}
                {sortField === key && sortOrder === 'descend' && <CaretDownOutlined />}
                {(!sortField || sortField !== key || !sortOrder) && (
                  <span className="sort-icon-placeholder"><CaretUpOutlined /></span>
                )}
              </span>
              {CALIBRATION_TEXT_FACET_COLUMNS.includes(key) ? renderTextColumnFilterTrigger(key) : null}
            </div>
            <div className="header-filter-input">
              <div className="heat-profile-inline-field-shell heat-profile-inline-field-shell--sm heat-profile-header-inline-shell">
                <Input
                  placeholder="Search"
                  size="small"
                  style={{ width: '120px' }}
                  value={columnFilters[key] || ''}
                  onChange={(e) => handleColumnFilterChange(key, e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            </div>
          </div>
        );
      }
      const calculatedWidth = Math.max(label.length * 15 + 40, 180);

      return {
        title,
        dataIndex: key,
        key,
        align: 'left',
        width: isDate ? 220 : calculatedWidth,
        minWidth: 150,
        sorter: true,
        sortOrder: sortField === key ? sortOrder : undefined,
        render: (val) => {
          if (isDate) return val ? moment(val).format('DD-MMM-YYYY') : '-';
          return val === undefined || val === null || val === '' ? '-' : String(val);
        },
      };
    });
    cols.push({
      title: 'ACTIONS',
      key: 'action',
      align: 'center',
      width: 160,
      // fixed: 'right', // ❌ Unpinned ACTIONS column
      render: (_, record) => {
        const max = getLatestCert(record);
        return (
          <div className="heat-profile-actions-cell">
            <Tooltip title="Update">
              <EditOutlined className="txtIcon" onClick={() => onUpdateClick(record)} />
            </Tooltip>
            {max?.certificateURL && (
              <Tooltip title="Download">
                <a href={max.certificateURL} target="_blank" rel="noopener noreferrer" className="txtIcon">
                  <FileExcelOutlined />
                </a>
              </Tooltip>
            )}
            {max?.certificateURL && (
              <Tooltip title="Share Certificate">
                <ShareAltOutlined className="txtIcon" onClick={() => showShareCalibrationModal(record)} />
              </Tooltip>
            )}
          </div>
        );
      },
    });
    return cols;
  }, [
    columnFilters,
    filterCalibrationDate,
    filterNextCalibrationDate,
    filterExpiration,
    sortField,
    sortOrder,
    embeddedInModernLayout,
    handleColumnFilterChange,
    handleSortClick,
    renderTextColumnFilterTrigger,
  ]);

  const totalCalibrationCount = sortedDataForModern.length;

  const tablePaginationModern = totalCalibrationCount > 0 ? {
    position: ['bottomRight'],
    className: 'heat-profile-pagination calibration-pagination',
    showSizeChanger: true,
    total: totalCalibrationCount,
    current: modernPageNumber,
    pageSize: modernPageSize,
    pageSizeOptions: ['10', '20', '50', String(totalCalibrationCount)],
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    locale: { items_per_page: '/ page' },
    onChange: (pageNumber, pageSize) => {
      setModernPageNumber(pageNumber);
      setModernPageSize(pageSize || 10);
    },
  } : false;

  const paginatedDataForModern = useMemo(() => {
    if (modernPageSize >= sortedDataForModern.length) return sortedDataForModern;
    const start = (modernPageNumber - 1) * modernPageSize;
    return sortedDataForModern.slice(start, start + modernPageSize);
  }, [sortedDataForModern, modernPageNumber, modernPageSize]);

  // Replace the numeric "All" option label (e.g. "884 / page") with "All / page"
  useEffect(() => {
    const totalStr = String(totalCalibrationCount);
    const replaceLabels = () => {
      // Selected value in the closed dropdown
      document.querySelectorAll('.calibration-pagination .ant-select-selection-item').forEach((el) => {
        if (el.textContent?.includes(totalStr) && el.textContent?.includes('/ page')) {
          el.textContent = 'All / page';
          el.title = 'All / page';
        }
      });
      // Dropdown option items (rendered in a portal)
      document.querySelectorAll('.ant-select-item-option-content').forEach((el) => {
        if (el.textContent?.includes(totalStr) && el.textContent?.includes('/ page')) {
          el.textContent = 'All / page';
        }
      });
    };
    replaceLabels();
    // Re-run on any pagination area DOM change (covers page changes, re-renders)
    const wrapper = document.querySelector('.calibration-pagination');
    const observer = wrapper ? new MutationObserver(replaceLabels) : null;
    if (observer && wrapper) observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
    // Catch dropdown opens (portal renders outside pagination)
    const handleClick = () => { setTimeout(replaceLabels, 50); setTimeout(replaceLabels, 150); };
    wrapper?.addEventListener('mousedown', handleClick);
    return () => { observer?.disconnect(); wrapper?.removeEventListener('mousedown', handleClick); };
  }, [totalCalibrationCount, modernPageSize]);

  const renderCalibrationBulkUploadPicker = () => (
    <div className="uploadFile_admin calibration-bulk-upload-custom">
      <p className="calibration-bulk-upload-custom__intro">
        Select Excel (.xlsx, .xls) or PDF files. You can queue up to 100 files, then press Upload.
      </p>
      <div className="calibration-bulk-upload-custom__zone">
        <input
          type="file"
          multiple
          accept={CALIBRATION_BULK_UPLOAD_ACCEPT}
          className="calibration-bulk-upload-custom__input"
          onChange={handleCalibrationFileInputChange}
          disabled={uploadLoading || disableFileUpload}
        />
        <div className="calibration-bulk-upload-custom__face" aria-hidden="true">
          <CloudUploadOutlined className="calibration-bulk-upload-custom__icon" />
          <span className="calibration-bulk-upload-custom__title">Tap here or anywhere in the box to browse</span>
          <span className="calibration-bulk-upload-custom__sub">Excel and PDF supported</span>
        </div>
      </div>
      <div className="calibration-bulk-upload-custom__toolbar">
        <Button
          type="link"
          disabled={uploadLoading || fileList.length === 0}
          onClick={clearCalibrationFileSelection}
        >
          Clear selection
        </Button>
      </div>
      {fileList.length > 0 && (
        <>
          <div className="calibration-bulk-upload-custom__summary" role="status">
            {fileList.length} file{fileList.length === 1 ? '' : 's'} selected
          </div>
          <div className="calibration-bulk-upload-custom__files">
            {fileList.map((file) => (
              <div
                className="calibration-bulk-upload-custom__file-chip"
                key={getCalibrationFileKey(file)}
              >
                <span className="calibration-bulk-upload-custom__file-name" title={file.name}>
                  {file.name}
                </span>
                <button
                  type="button"
                  className="calibration-bulk-upload-custom__file-remove"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    removeCalibrationSelectedFile(file);
                  }}
                  aria-label={`Remove ${file.name}`}
                >
                  <CloseOutlined />
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );

  if (embeddedInModernLayout) {
    return (
      <>
        <div className="heat-profile-card">
          <div className="heat-profile-list-header">
            <div className="heat-profile-header-left">
              <div className="heat-profile-icon-wrap">
                <ToolOutlined style={{ fontSize: 22 }} />
              </div>
              <div className="heat-profile-header-content">
                <div className="heat-profile-title-row">
                  <h3 className="heat-profile-list-title">List of Calibration</h3>
                  <span className="heat-profile-summary">
                    {calibrationTotalCount != null ? calibrationTotalCount : (rawDataList?.length ?? 0)} item{((calibrationTotalCount != null ? calibrationTotalCount : rawDataList?.length) ?? 0) !== 1 ? 's' : ''}
                  </span>
                </div>
                <p className="heat-profile-list-description">
                  Manage calibration certificates, instruments, and compliance data.
                </p>
              </div>
            </div>
            <div className="heat-profile-header-actions calibration-modern-actions">
              <CrcButton
                label="Download template"
                variant="tertiary"
                icon={LayoutTemplate}
                onClick={handleDownloadTemplate}
                size="small"
              />
              <CrcButton
                label="Download As Excel"
                variant="tertiary"
                icon={FileSpreadsheet}
                onClick={handleDownloadData}
                size="small"
                loading={downloadLoading}
              />
              <CrcButton
                label="Bulk Upload"
                variant="tertiary"
                icon={Upload}
                onClick={showBulkUploadModal}
                size="small"
              />
              <CrcButton label="Add New" variant="primary" icon={Plus} onClick={() => { setIsEdit(false); setIsModalVisible(true); }} size="small" />
              {selectedRows.length > 0 && (
                <CrcButton
                  label={
                    pdfGenerationLoading
                      ? 'Generating Report...'
                      : `Combined Report (${selectedRows.length})`
                  }
                  variant="secondary"
                  onClick={() => {
                    if (!pdfGenerationLoading) {
                      handleGeneratePdf();
                    }
                  }}
                  size="small"
                  disabled={pdfGenerationLoading}
                />
              )}
            </div>
          </div>
          <div className="addTeamDetails heat-profile-table-wrap">
            <Table
              columns={modernColumnsWithFilters}
              dataSource={paginatedDataForModern}
              rowKey="ID"
              loading={{ indicator: <Spinner variant="inline" size="medium" />, spinning: isRawListLoading }}
              className="h-100 pipeline-table equipPaginationTable heat-profile-table"
              scroll={{ x: 2400 }}
              pagination={tablePaginationModern}
              rowSelection={{
                type: 'checkbox',
                selectedRowKeys: selectedRows.map((r) => r.ID),
                onChange: (selectedRowKeys, selectedRowsData) => {
                  setSelectedRows(selectedRowsData || []);
                },
                columnWidth: 56,
                columnTitle: (() => {
                  const currentPageIds = paginatedDataForModern.map((r) => r.ID);
                  const selectedOnPage = selectedRows.filter((r) => currentPageIds.includes(r.ID));
                  const allSelected = currentPageIds.length > 0 && selectedOnPage.length === currentPageIds.length;
                  const indeterminate = selectedOnPage.length > 0 && selectedOnPage.length < currentPageIds.length;
                  return (
                    <div className="calibration-table-header-checkbox" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: 8, paddingRight: 8, minWidth: 36, overflow: 'visible' }} onClick={(e) => e.stopPropagation()}>
                      <Checkbox
                        checked={allSelected}
                        indeterminate={indeterminate}
                        onChange={(checkedOrEvent) => {
                          const checked = typeof checkedOrEvent === 'boolean' ? checkedOrEvent : (checkedOrEvent?.target?.checked ?? false);
                          const currentIds = paginatedDataForModern.map((r) => r.ID);
                          setSelectedRows((prev) => {
                            const prevOthers = prev.filter((r) => !currentIds.includes(r.ID));
                            return checked ? [...prevOthers, ...paginatedDataForModern] : prevOthers;
                          });
                        }}
                        borderColor="#00C9A7"
                        aria-label="Select all rows on page"
                      />
                    </div>
                  );
                })(),
                renderCell: (checked, record) => (
                  <div className="calibration-table-cell-checkbox" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: 8, paddingRight: 8, minWidth: 36, overflow: 'visible' }} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                      checked={!!checked}
                      onChange={(checkedOrEvent) => {
                        const newChecked = typeof checkedOrEvent === 'boolean' ? checkedOrEvent : (checkedOrEvent?.target?.checked ?? false);
                        if (newChecked) {
                          setSelectedRows((prev) => (prev.some((r) => r.ID === record.ID) ? prev : [...prev, record]));
                        } else {
                          setSelectedRows((prev) => prev.filter((r) => r.ID !== record.ID));
                        }
                      }}
                      borderColor="#00C9A7"
                      aria-label={`Select row ${record.ID}`}
                    />
                  </div>
                ),
              }}
            />
          </div>
        </div>
        {isModalVisible && (
          <ProjectModal
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            projectDetailForm={projectDetailForm}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            editRecord={editRecord}
            seteditRecord={seteditRecord}
            setShowPipelineModel={setShowPipelineModel}
            setProjectDetails={setProjectDetails}
            fetchCalibrationData={fetchCalibrationData}
            rawDataList={rawDataList}
          />
        )}
        <Modal
          className="heatprofile-modal"
          title="Upload Calibration"
          centered
          open={bulkUploadModal}
          onCancel={handleCancelUploadFile}
          footer={[
            <Button key="cancel" onClick={handleCancelUploadFile}>
              Cancel
            </Button>,
            <Button
              key="apply"
              type="primary"
              onClick={handleUploadFile}
              loading={uploadLoading}
            >
              {uploadLoading ? 'Uploading' : 'Upload'}
            </Button>,
          ]}
        >
          {renderCalibrationBulkUploadPicker()}
        </Modal>
        <Modal
          className="heatprofile-modal"
          title="Share Calibration Certificate"
          centered
          open={shareCalibrationModal}
          onCancel={handleCancelShareCalibrationModal}
          footer={[
            <Button key="cancel" onClick={handleCancelShareCalibrationModal}>
              Cancel
            </Button>,
            <Button key="apply" type="primary" onClick={shareCalibration}>
              Share
            </Button>,
          ]}
        >
          <div className="uploadFile_admin">
            <Input
              placeholder="Enter Emails Followed By Comma (,)"
              style={{ height: '40px', borderRadius: '8px' }}
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
            />
            <div style={{ marginTop: '8px', fontSize: '12px', color: '#6b7280' }}>
              eg: 1234@mail.com, 234@email.com
            </div>
          </div>
        </Modal>
      </>
    );
  }

  return (
    <div className="d-flex flex-column h-100">
      {!showPipelineModel && (
        <div className="flex-auto">
          <div className="flex-auto">
            <div className="d-flex mb-3 align-items-center tab-content-title">
              <div className="back_heatp_modal">
                <Tooltip title={'Back'}>
                  <ArrowLeftOutlined
                    onClick={() => {
                      history.push('/calibration-control');
                    }}
                  />
                </Tooltip>
              </div>
              {/* <Title className="mb-0 add-new-calibration" level={3} style={{ paddingLeft: '20px' }}>
                                List of Calibration
                            </Title> */}

              <Typography
                className="project-title"
                style={{ fontSize: '25px', paddingLeft: '20px' }}
                level={4}
              >
                List of Calibration
              </Typography>
              <div className="new-calibration new-project-team">
                <Text
                  onClick={() => {
                    setIsEdit(false);
                    setIsModalVisible(true);
                  }}
                  className="ps-3 add-new-team"
                >
                  <span className="icon-22">
                    <svg>
                      <use xlinkHref="#add" />
                    </svg>
                  </span>
                  Add New
                </Text>
                <Text onClick={handleDownloadTemplate} className="ps-3 add-new-team">
                  <span className="icon-22">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 3v18M5 12l7 7 7-7"></path>
                    </svg>
                  </span>
                  Download template
                </Text>
                <Text
                  onClick={() => {
                    handleDownloadData();
                  }}
                  className="ps-3 add-new-team"
                >
                  <span className="icon-22">
                    <FileSpreadsheet size={18} strokeWidth={2} aria-hidden />
                  </span>
                  Download As Excel
                </Text>
                <Text onClick={showBulkUploadModal} className="ps-3 add-new-team">
                  <span className="icon-22">
                    <Upload size={18} strokeWidth={2} aria-hidden />
                  </span>
                  Bulk Upload
                </Text>

                {selectedRows.length > 0 && (
                  <Text
                    onClick={() => {
                      if (!pdfGenerationLoading) {
                        handleGeneratePdf();
                      }
                    }}
                    className="ps-3 add-new-team"
                    style={{
                      cursor: pdfGenerationLoading ? 'not-allowed' : 'pointer',
                      opacity: pdfGenerationLoading ? 0.6 : 1,
                      pointerEvents: pdfGenerationLoading ? 'none' : 'auto',
                    }}
                  >
                    {pdfGenerationLoading
                      ? 'Generating Report...'
                      : `Combined Report (${selectedRows.length})`
                    }
                  </Text>
                )}
              </div>
            </div>

            <div className="custom-line" />

            {getPipelineTabpanes()}
          </div>
        </div>
      )}

      {isModalVisible && (
        <ProjectModal
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          projectDetailForm={projectDetailForm}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          editRecord={editRecord}
          setShowPipelineModel={setShowPipelineModel}
          setProjectDetails={setProjectDetails}
          fetchCalibrationData={fetchCalibrationData}
          rawDataList={rawDataList}
        />
      )}

      <Modal
        className="heatprofile-modal"
        title="Upload Calibration"
        centered
        open={bulkUploadModal}
        onCancel={handleCancelUploadFile}
        footer={[
          <Button key="cancel" onClick={handleCancelUploadFile}>
            Cancel
          </Button>,
          <Button key="apply" type="primary" onClick={handleUploadFile} loading={uploadLoading}>
            {uploadLoading ? 'uploading' : 'Upload'}
          </Button>,
        ]}
      >
        {renderCalibrationBulkUploadPicker()}
      </Modal>

      <Modal
        className="heatprofile-modal"
        title="Share Calibration Certificate"
        centered
        open={shareCalibrationModal}
        onCancel={handleCancelShareCalibrationModal}
        footer={[
          <Button key="cancel" onClick={handleCancelShareCalibrationModal}>
            Cancel
          </Button>,
          <Button key="apply" type="primary" onClick={shareCalibration}>
            Share
          </Button>,
        ]}
      >
        <div className="uploadFile_admin">
          <Input
            placeholder="Enter Emails Followed By Comma (,)"
            style={{ height: '40px', borderRadius: '8px' }}
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
          />
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#6b7280' }}>
            eg: 1234@mail.com, 234@email.com
          </div>
        </div>
      </Modal>

      <Modal
        width="45vw"
        className="heatprofile-modal"
        title="Delete"
        centered
        visible={isDeleteModalVisible}
        onCancel={handleDeleteCancel}
        footer={[
          <Button key="cancel" onClick={handleDeleteCancel}>
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleDeleteOk}
            loading={isDeleteLoading}
          >
            {isDeleteLoading ? 'Deleting' : 'Delete'}
          </Button>,
        ]}
      >
        <div>
          <Text style={{ fontSize: '16px' }}>
            <p>Deleting calibration will delete all the corresponding related information.</p>Are
            you sure you want to delete{' '}
            <b style={{ color: '#EF314C' }}>{selectedData && selectedData.Instrument_Company}</b>{' '}
            Calibration?
          </Text>
        </div>
      </Modal>
    </div>
  );
};
const mapStateToProps = ({ calibrationReducer }) => {
  const rawDataList = get(calibrationReducer, 'calibrationData', []);
  const isRawListLoading = get(calibrationReducer, 'iscalbrationLoading', false);
  const isUploadCalibration = get(calibrationReducer, 'isUploadCalibration', false);
  const calibrationTotalCount = get(calibrationReducer, 'calibrationTotalCount', null);
  return {
    rawDataList,
    isRawListLoading,
    isUploadCalibration,
    calibrationTotalCount,
  };
};

const mapDispatchToProps = {
  onFetchCalibration: fetchCalibration,
  onShareCalibration: shareCalibration,
  onUploadCalibrationFile: uploadCalibrationFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(CalibrationMainPage);
